export const normalizePhoneNumber = (raw) => {
  if (!raw) return "";
  return String(raw).trim().replace(/[^\d+]/g, "");
};

export const isAllowedPhoneNumber = (raw) => {
  const number = normalizePhoneNumber(raw);
  return /^\+?[1-9]\d{6,14}$/.test(number);
};

export const formatPhoneNumberForDisplay = (raw) => {
  const number = normalizePhoneNumber(raw);

  if (!number) return "N/A";

  const digits = number.replace(/^\+/, "");

  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  if (digits.length === 11 && digits.startsWith("1")) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }

  return number;
};
